import { checkForLocalAuthToken } from 'models/AuthModel';
import axios from 'services/axios';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

interface UnmatchProductProps {
  org_id: string;
  mapping_id: string;
  operation_ids: string[];
}

interface UnmatchProductReturn {
  hasError: boolean;
}
const token = checkForLocalAuthToken();

export const unmatchProduct = async ({
  org_id,
  mapping_id,
  operation_ids,
}: UnmatchProductProps): Promise<UnmatchProductReturn> => {
  try {
    const encodedMappingId = encodeURIComponent(mapping_id);
    await axios.post(
      `${VITE_APP_API_URL}/valet/v2/operation-data-unmapping?org_id=${org_id}&mapping_id=${encodedMappingId}`,
      {
        operation_ids,
      },
      {
        headers: { authorization: `Bearer ${token?.access_token}` },
      },
    );

    return {
      hasError: false,
    };
  } catch (err: any) {
    return { hasError: true };
  }
};
